module.exports = __webpack_public_path__ + "static/img/fayuan-icon7.f64520dd.png";